// copy from RegistrationRepository.js
export const formatErrors = (error, errors) => {
	const result = [];

	if (error) {
		result.push(error);
	}

	for (let field in errors) {
		if (errors.hasOwnProperty(field)) {
			const mistakes = [];
			const messages = errors[field];
			for (let validatorId in messages) {
				if (messages.hasOwnProperty(validatorId)) {
					mistakes.push(messages[validatorId]);
				}
			}
			result.push(this.translateField(field) + ': ' + mistakes.join(', '));
		}
	}

	return result;
};



// WEBPACK FOOTER //
// ./components/payments/adyen/Adyen/utils.js